import Layout from '../components/Layout'
import { IubendaComp } from "../components/IubendaComp";


export async function getStaticProps() {
    // Call an external API endpoint to get posts.
    // You can use any data fetching library
    const res = await fetch('https://www.iubenda.com/api/privacy-policy/97728650/cookie-policy/no-markup')
    const data = await res.json()
    // console.log(data)

    // By returning { props: { posts } }, the Blog component
    // will receive `posts` as a prop at build time
    return {
        props: {
            contentStr: data.content,
        },
    }
}

// @ts-ignore
export default function CookiePolicyPage({ contentStr }) {
    // @ts-ignore
    return (
        <Layout title="Cookie Policy">
            <IubendaComp content={contentStr}/>
        </Layout>
    )
}